import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

function initGradientWaveText() {
  document.querySelectorAll('[data-gradient-wave-text]').forEach((heading) => {
    const scrollStart = heading.getAttribute('data-gradient-wave-scroll-start') || 'top 90%';
    const scrollEnd = heading.getAttribute('data-gradient-wave-scroll-end') || 'center 40%';
    const startColor = heading.getAttribute('data-gradient-wave-color-start') || 'rgba(255, 255, 255, 0.2)';
    const waveColor = heading.getAttribute('data-gradient-wave-color-wave') || '#F84131';
    const waveDuration = parseFloat(heading.getAttribute('data-gradient-wave-duration')) || 0.4;
    const scrubValue = parseFloat(heading.getAttribute('data-gradient-wave-scrub')) || 0.1;
    const blurAmount = heading.getAttribute('data-gradient-wave-blur') || '6px';
    const startBlur = `blur(${blurAmount})`;
    const endBlur = 'blur(0px)';

    // GSAP parses sRGB syntax only: an oklch()/lab() computed color is read as
    // rgb(l, c, h) and lands on a random hue, so an explicit end color wins.

    const endColor = heading.getAttribute('data-gradient-wave-color-end') || getComputedStyle(heading).color;

    new SplitText(heading, {
      type: 'words, chars',
      autoSplit: true,
      onSplit(self) {
        const chars = self.chars;
        const activeChars = new Set();
        const progress = { value: 0 };
        let isReady = false;

        const syncChars = () => {
          const activeCount = Math.round(progress.value * chars.length);

          chars.forEach((char, index) => {
            const isActive = index < activeCount;
            gsap.killTweensOf(char);
            gsap.set(char, {color: isActive ? endColor : startColor, filter: isActive ? endBlur : startBlur});
            if (isActive) activeChars.add(char);
            else activeChars.delete(char);
          });
        };

        const ctx = gsap.context(() => {
          gsap.set(chars, {color: startColor, filter: startBlur});

          gsap.to(progress, {
            value: 1,
            ease: 'none',
            scrollTrigger: {
              trigger: heading,
              start: scrollStart,
              end: scrollEnd,
              scrub: scrubValue,
              onRefresh: () => {
                isReady = false;
                syncChars();
                requestAnimationFrame(() => {
                  isReady = true;
                });
              }
            },
            onUpdate: () => {
              if (!isReady) return;

              const activeCount = Math.round(progress.value * chars.length);
              chars.forEach((char, index) => {
                const isActive = index < activeCount;

                if (isActive && !activeChars.has(char)) {
                  activeChars.add(char);
                  gsap.killTweensOf(char);

                  gsap.timeline()
                    .to(char, {
                      color: waveColor,
                      filter: endBlur,
                      duration: waveDuration * 0.3,
                      ease: 'power2.out'
                    })
                    .to(char, {
                      color: endColor,
                      duration: waveDuration * 0.7,
                      ease: 'power2.in'
                    });
                }

                if (!isActive && activeChars.has(char)) {
                  activeChars.delete(char);
                  gsap.killTweensOf(char);

                  gsap.to(char, {
                    color: startColor,
                    filter: startBlur,
                    duration: waveDuration * 0.5,
                    ease: 'none'
                  });
                }
              });
            }
          });
        }, heading);

        return ctx;
      }
    });
  });
}

// Initialize Gradient Wave Text on Scroll
document.addEventListener('DOMContentLoaded', () => {
  initGradientWaveText();
});
